import { BaseController } from '../../common/base/controller';

export class LegalController extends BaseController {
  constructor(controllerService, configService) {
    'ngInject';
    super({
      controllerService,
      configService,
    });
  }

  $onInit() {
    const config = this.configService.config;
    this.document = config.documents.links[this.$stateParams.document];
    this.getDocument(this.document);
  }

  getDocument(document) {
    const { tenant } = this.configService.config;
    this.configService.fetchLegalContent(tenant, document).then((resp) => {
      this.markdown = resp.data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/legal/legal.controller.js